import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  backgroundPlayer: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    zIndex: 5,
  },
  inlineVideo: {
    width: "100%",
    height: "auto",
    objectFit: "cover"
  }
}));
